import React from 'react';
import { BusinessCardArtwork } from './business-card/BusinessCardArtwork';
/**
 * Dentico Business Card — Ukrainian (Dentico_Business_Card_UA)
 * Independent document duplicated from the approved English master. Only the
 * front-side subtitle differs; logo, contacts, QR (WHATSAPP US → WhatsApp chat),
 * address and all layout/print settings are identical.
 */
export function BusinessCardNewUaPage() {
  return <BusinessCardArtwork docName="Dentico Business Card — Ukrainian" subtitle={['Українська стоматологічна', 'клініка в Лондоні']} data-id="element-1290" data-mp="2tob8seey52dz" />;
}